




















































import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  props: {
    isLoadingEditing: { type: Boolean, default: false },
    isLoadingUnlink: { type: Boolean, default: false },
    isEditing: { type: Boolean, required: true },
    canUpdate: { type: Boolean, default: true },
    disableUnlink: { type: Boolean, default: false },
    value: { type: String, required: false },
  },
  emits: ["edit", "update", "unlink"],
  methods: {
    onEdit() {
      this.$emit("edit");
    },
    onUpdate() {
      this.$emit("update");
    },
    onUnlink() {
      this.$emit("unlink");
    },
  },
});
